// Banner pra subscriptions com status pending_cancellation — Story 3.6.
import { AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import { formatDayBR } from '@control-center/shared';

import { PillButton } from '../clients/PillButton';
import { useRevertPendingCancellation } from '../../hooks/use-subscriptions';
import { extractErrorMessage } from '../../lib/errors';

interface PendingCancellationBannerProps {
  subscriptionId: string;
  pendingCancellationAt: string | null;
}

export function PendingCancellationBanner({
  subscriptionId,
  pendingCancellationAt,
}: PendingCancellationBannerProps): JSX.Element {
  const revert = useRevertPendingCancellation();
  // Recebe nextBillingDate/endDate — dia puro (@db.Date): formatBR aplicava
  // fuso e mostrava o dia anterior.
  const dueLabel = pendingCancellationAt
    ? formatDayBR(pendingCancellationAt)
    : 'data não definida';

  async function handleRevert(): Promise<void> {
    try {
      await revert.mutateAsync(subscriptionId);
      toast.success('Cancelamento revertido.');
    } catch (err) {
      toast.error(extractErrorMessage(err, 'Não conseguimos reverter.'));
    }
  }

  return (
    <div className="flex items-center justify-between gap-3 rounded-[10px] border border-warn/40 bg-warn/10 px-3 py-2 text-[12px]">
      <div className="flex items-center gap-2 text-warn">
        <AlertTriangle size={13} strokeWidth={2} aria-hidden />
        Será cancelada em <strong className="tnum">{dueLabel}</strong>
      </div>
      <PillButton type="button" onClick={() => void handleRevert()} disabled={revert.isPending}>
        {revert.isPending ? 'Revertendo…' : 'Reverter'}
      </PillButton>
    </div>
  );
}
